import { useEffect, useState } from "react";
import { getMPKChangeLog, MPKChangeLogDTO } from "../api/mpk";

export function useMpkChangeLog(
  documentId: string,
  companyId: string
) {
  const [rows, setRows] = useState<MPKChangeLogDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function load() {
      setLoading(true);
      try {
        const data = await getMPKChangeLog(companyId, documentId);
        if (active) setRows(data);
      } finally {
        if (active) setLoading(false);
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [documentId, companyId]);

  return { rows, loading };
}
